export default "__VITE_ASSET__D4WfMV0M__"